import { MODALS_DATA_URL } from '../../constants/apiUrls/apiUrls';
import http from '../../services/http';


export const dismissModal = (payload) => http.post(MODALS_DATA_URL, payload);
